import React, { useMemo, useState, useCallback } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { list } from "./data";
import ListForm from "./ListForm";
import styled from "@mui/material/styles/styled";
const checkBoxStyle = {
    color: "#533278",
};
const CheckListWrapper = styled("section")(({ theme }) => ({
    ".helper-text": {
        color: "red",
        fontSize: 12,
        marginLeft: 25,
        fontFamily: 'Roboto'
    },
    '.captionText': {
        fontSize: '.813em',
        fontWeight: 600,
        margin: '40px 0 20px !important',
        fontFamily: 'Roboto'
    },
    '.MuiFormControlLabel-label': {
        color: 'rgb(71, 130, 196)',
        fontSize: '.813em',
    }
}));
export const CheckList = (props) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const onChangeHandler = useCallback((selected) => {
        return () => {
            return setSelectedItem(selected);
        };
    }, []);
    const checkListDetails = useMemo(() => {
        return list(props.selectedReference || {}).map((detail) => (Object.assign({}, detail)));
    }, [props.selectedReference]);
    return (React.createElement(CheckListWrapper, null,
        React.createElement("p", { className: "captionText" }, "Click each checklist item to fill in the required information."),
        React.createElement(FormGroup, null, checkListDetails.map((detail) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(FormControlLabel, Object.assign({ onChange: onChangeHandler(detail), control: React.createElement(Checkbox, { defaultChecked: true, style: checkBoxStyle }) }, detail)),
                React.createElement("span", { className: "helper-text" }, detail.helperText)));
        })),
        selectedItem && (React.createElement(ListForm, { selectedItem: selectedItem, selectedReference: props.selectedReference, setModalValues: (val) => {
                if (val) {
                    props.setModalValues(val);
                    setSelectedItem(null);
                }
                else {
                    props.setModalValues(null);
                    setSelectedItem(null);
                }
            } }))));
};
